/**
 * Actualiza el bloque de precios cuando cambia la variante.
 * Compatible con temas tipo Dawn que despachan eventos "variant:change".
 */
(function () {
  function formatUsd(amount) {
    if (amount === '' || amount === undefined || amount === null) {
      return '';
    }
    const value = Number(amount);
    if (Number.isNaN(value)) {
      return '';
    }
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(value);
  }

  function updateBlock(block, variantId, usdPrice, isForeign) {
    if (!block) return;
    block.dataset.variantId = variantId;
    block.dataset.usdPrice = usdPrice || '';
    block.dataset.isForeign = String(isForeign);

    const usdBlock = block.querySelector('[data-role="usd-block"]');
    const usdAmount = usdBlock ? usdBlock.querySelector('.benard-price-block__usd-amount') : null;
    const usdLabel = usdBlock ? usdBlock.querySelector('.benard-price-block__usd-label') : null;
    if (usdBlock && usdAmount && usdLabel) {
      if (usdPrice) {
        usdAmount.textContent = formatUsd(usdPrice);
        usdLabel.textContent = isForeign ? 'Tu precio en USD:' : 'Referencia USD:';
        usdBlock.hidden = false;
      } else {
        usdBlock.hidden = true;
      }
    }

    const paypalHint = block.querySelector('[data-role="paypal-hint"]');
    if (paypalHint) {
      paypalHint.hidden = !isForeign;
    }
  }

  document.addEventListener('variant:change', (event) => {
    const { variant, sectionId } = event.detail || {};
    if (!variant) return;
    const block = document.querySelector(
      `.benard-price-block[data-section-id="${sectionId || ''}"]`
    );
    if (!block) return;

    const usdMetafields = variant?.metafields?.international?.usd_price;
    const usdPrice = usdMetafields?.value || usdMetafields || block.dataset.usdPrice;
    const isForeign = block.dataset.isForeign === 'true';
    updateBlock(block, variant.id, usdPrice, isForeign);
  });
})();
